import { render, staticRenderFns } from "./ShowMinusDeteadLogList.vue?vue&type=template&id=00ce467d&"
import script from "./ShowMinusDeteadLogList.vue?vue&type=script&lang=js&"
export * from "./ShowMinusDeteadLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports